import { Theme } from "@emotion/react";
import Box from "@mui/material/Box";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import { SxProps } from "@mui/material/styles";
import { CodeCheckboxField } from "../../organisms/QARuleForm/defaultCQAConfig";

const CMX_CHECKED_ICON = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.78794 16C1.28571 16 0.862158 15.8276 0.517295 15.4827C0.172432 15.1378 0 14.7143 0 14.2121V1.78794C0 1.28571 0.172432 0.862158 0.517295 0.517295C0.862158 0.172432 1.28571 0 1.78794 0H14.2121C14.7143 0 15.1378 0.172432 15.4827 0.517295C15.8276 0.862158 16 1.28571 16 1.78794V14.2121C16 14.7143 15.8276 15.1378 15.4827 15.4827C15.1378 15.8276 14.7143 16 14.2121 16H1.78794ZM1.78794 14.4944H14.2121C14.2904 14.4944 14.357 14.4669 14.412 14.412C14.4669 14.357 14.4944 14.2904 14.4944 14.2121V1.78794C14.4944 1.70963 14.4669 1.64299 14.412 1.58803C14.357 1.53306 14.2904 1.50558 14.2121 1.50558H1.78794C1.70963 1.50558 1.64299 1.53306 1.58803 1.58803C1.53306 1.64299 1.50558 1.70963 1.50558 1.78794V14.2121C1.50558 14.2904 1.53306 14.357 1.58803 14.412C1.64299 14.4669 1.70963 14.4944 1.78794 14.4944ZM6.72935 11.3184C6.83929 11.3184 6.94922 11.2984 7.05916 11.2585C7.16834 11.2194 7.27037 11.1452 7.36524 11.036L12.5179 5.88225C12.6594 5.74145 12.734 5.56901 12.7415 5.36496C12.749 5.1609 12.6745 4.98056 12.5179 4.82394C12.3612 4.66657 12.1809 4.58789 11.9768 4.58789C11.7728 4.58789 11.6 4.66657 11.4584 4.82394L6.72935 9.55301L4.58789 7.41155C4.44708 7.27074 4.27841 7.1962 4.08189 7.18791C3.88611 7.18039 3.70954 7.25493 3.55217 7.41155C3.39555 7.56892 3.31724 7.74549 3.31724 7.94127C3.31724 8.13704 3.39555 8.31361 3.55217 8.47099L6.09346 11.036C6.18834 11.1452 6.29037 11.2194 6.39955 11.2585C6.50948 11.2984 6.61942 11.3184 6.72935 11.3184Z" fill="#8CB4C2" />
</svg>;

const CMX_UNCHECKED_ICON = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1.61993 16C1.16462 16 0.780596 15.844 0.467872 15.5321C0.155957 15.2194 0 14.8354 0 14.3801V1.61993C0 1.16462 0.155957 0.780596 0.467872 0.467872C0.780596 0.155957 1.16462 0 1.61993 0H14.3801C14.8354 0 15.2194 0.155957 15.5321 0.467872C15.844 0.780596 16 1.16462 16 1.61993V14.3801C16 14.8354 15.844 15.2194 15.5321 15.5321C15.2194 15.844 14.8354 16 14.3801 16H1.61993ZM1.61993 14.6839H14.3801C14.4473 14.6839 14.515 14.6503 14.583 14.583C14.6503 14.515 14.6839 14.4473 14.6839 14.3801V1.61993C14.6839 1.55269 14.6503 1.48504 14.583 1.41698C14.515 1.34974 14.4473 1.31612 14.3801 1.31612H1.61993C1.55269 1.31612 1.48504 1.34974 1.41698 1.41698C1.34974 1.48504 1.31612 1.55269 1.31612 1.61993V14.3801C1.31612 14.4473 1.34974 14.515 1.41698 14.583C1.48504 14.6503 1.55269 14.6839 1.61993 14.6839Z" fill="#8CB4C2" />
</svg>;

type CheckboxGroupProps = {
  fields: CodeCheckboxField[];
  values: { [key: string]: boolean };
  onChange: (field: string, checked: boolean) => void;
  stylesBox?: SxProps<Theme>;
  stylesCheckbox?: SxProps<Theme>;
};

const CheckboxGroup: React.FC<CheckboxGroupProps> = ({ fields, values, onChange, stylesBox, stylesCheckbox = {} }) => {
  return (
    <Box display="flex" flexDirection="row" justifyContent="flex-start" sx={stylesBox}>
      {/* Loop through each field and create a checkbox for each */}
      {fields.map((field) => (
        <FormGroup key={field.key} row>
          <FormControlLabel
            control={
              <Checkbox
                checked={values[field.key]}
                onChange={(e) => onChange(field.key, e.target.checked)}
                disabled={field.disabled}
                name={field.key}
                checkedIcon={CMX_CHECKED_ICON}
                icon={CMX_UNCHECKED_ICON}
                sx={stylesCheckbox}
              />
            }
            label={field.label}
          />
        </FormGroup>
      ))}
    </Box>
  );
};

export default CheckboxGroup;